import type { FC, ReactNode } from 'react'

import { Check } from 'lucide-react'
import { Logo } from '@/components/generals/logo'

interface AuthShellProps {
    title: string
    subtitle: string
    children: ReactNode
    footer?: ReactNode
}

const POINTS = [
    'Paste a blog link and get a full carousel',
    'Style every slide in the built-in designer',
    'See the post in your grid before you share it'
]

const TILES = ['#FF6B4A', '#1F1C19', '#FFD43B', '#F4EEE3', '#6D28D9', '#1E3A8A', '#E9EEF3', '#FF6B4A', '#121110']

export const AuthShell: FC<AuthShellProps> = ({ title, subtitle, children, footer }): ReactNode => (
    <div className='grid min-h-screen lg:grid-cols-[minmax(0,1fr)_minmax(0,0.9fr)]'>
        <div className='flex flex-col px-6 py-8 sm:px-12'>
            <Logo />

            <div className='mx-auto flex w-full max-w-sm flex-1 flex-col justify-center py-12'>
                <h1 className='text-3xl font-bold sm:text-4xl'>
                    {title}
                </h1>
                <p className='mt-2 text-muted-foreground'>
                    {subtitle}
                </p>

                <div className='mt-8'>
                    {children}
                </div>

                {footer && (
                    <div className='mt-8 text-sm text-muted-foreground'>
                        {footer}
                    </div>
                )}
            </div>
        </div>

        <aside className='relative hidden overflow-hidden bg-ink p-12 text-paper lg:flex lg:flex-col lg:justify-between' aria-label='Why Feedsmith'>
            <div className='grid w-64 grid-cols-3 gap-1.5 self-end' aria-hidden='true'>
                {TILES.map((color, index) => (
                    <div key={index} className='aspect-[3/4] rounded-sm' style={{ backgroundColor: color, opacity: index === 4 ? 1 : 0.92 }} />
                ))}
            </div>

            <div className='max-w-md'>
                <p className='font-heading text-4xl leading-tight font-bold'>
                    Blog posts in, <span className='text-coral'>scroll-stopping</span> carousels out.
                </p>

                <ul className='mt-8 flex flex-col gap-3'>
                    {POINTS.map(point => (
                        <li key={point} className='flex items-start gap-3 text-paper/85'>
                            <span className='mt-0.5 flex size-5 shrink-0 items-center justify-center rounded-full bg-coral text-ink'>
                                <Check className='size-3.5' />
                            </span>
                            {point}
                        </li>
                    ))}
                </ul>
            </div>
        </aside>
    </div>
)
